import { render, staticRenderFns } from "./delivery-point-item.vue?vue&type=template&id=e92235b0&scoped=true&"
import script from "./delivery-point-item.vue?vue&type=script&lang=js&"
export * from "./delivery-point-item.vue?vue&type=script&lang=js&"
import style0 from "./delivery-point-item.vue?vue&type=style&index=0&id=e92235b0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e92235b0",
  null
  
)

export default component.exports